module.exports = __webpack_public_path__ + "img/product2_FF6B00_date.5316a1ef.png";